import { WalletIcon } from './WalletIcon';

/**
 * author: Google
 * id C5ABA786-D897-4770-AA78-CE4CB2A9230E
 * name wallet
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const AccountBalanceWalletIcon = WalletIcon;
export default AccountBalanceWalletIcon